import { render, staticRenderFns } from "./CoreMenu.vue?vue&type=template&id=01c96dfe&scoped=true&"
import script from "./CoreMenu.vue?vue&type=script&lang=ts&"
export * from "./CoreMenu.vue?vue&type=script&lang=ts&"
import style0 from "./CoreMenu.vue?vue&type=style&index=0&id=01c96dfe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c96dfe",
  null
  
)

export default component.exports